import md5 from 'md5';

const FOR_SALE_IMAGE_URL_REGEX =
  /^(.*?)(?:\/m2|\/m)?\/for-sale\/[a-f0-9]{2}-([a-z0-9]{17})(\/img-\d+-[^?#]+)([?#].*)?$/i;

export function getM2ForSaleUrl(url) {
  if (!url || typeof url !== 'string') {
    return url;
  }

  const matches = url.match(FOR_SALE_IMAGE_URL_REGEX);

  if (!matches) {
    return url;
  }

  const [, baseUrl, vin, imagePath, suffix = ''] = matches;
  const normalizedVin = vin.toUpperCase();
  const first2char = md5(normalizedVin).substring(0, 2);

  return `${baseUrl}/m2/for-sale/${first2char}-${normalizedVin}${imagePath}${suffix}`;
}
